// flex 관련 설정
export const contentStart = "flex-start";
export const contentEnd = "flex-end";
export const contentCenter = "center";
export const spaceAround = "space-around";

// 공통 스타일 관련 설정
export const commonBgColor = "#eee";
export const commonFontWeight700 = 700;
export const commonH1Size = "max(1.5vw, 22px)";
export const commonH1Padding = "24px 0";
export const commonBodyPadding = "0px 40px 15px";
export const commonBodyPadding2 = "0px 40px";
export const commonGap = "24px";

// VendorInfo > 스타일 설정
export const infoPadding = "0 2em";
export const infoPadding2 = "0 2em 0 0";
export const infoPadding3 = "0 0 0 2em";
export const infoFontSize1 = "min(4.3vw, 25px)";
export const infoFontSize2 = "min(2vw, 20px)";
export const infoFontColor1 = "#B7B7B7";
export const infoFontColor2 = "#FE531F";
export const infoFontColor3 = "#000";
export const infoFontColor4 = "#A4A4A4";
export const infoEm = "1em";
export const infoHeight = "335px";
export const infoBorderColor = "1px solid #D9D9D9";
export const infoBorderColor2 = "1px solid #FE531F";

// VendorInfo > 메시지 관련 설정
export const success = "정상";
export const error = "오류";
export const systemEnd = "시스템 종료";
export const systemStart = "시스템 시작";
export const adminConnect = "본사 연결";

// VendorSale > 스타일 설정
export const saleFontSize1 = "max(1.2vw, 20px)";
export const saleMargin1 = "0.2em 2em";
export const salePadding1 = "1.5em 0";

// VendorDevice > 스타일 설정
export const deviceEm = "1.5em";

// VendorDevice > 메시지 관련 설정
export const errorManegement = "오류 관리";

// VendorError > 스타일 설정
export const commonErrorAcceptSize = "max(2vw, 30px)";

// VendorStats > 스타일 설정
export const statsOuterPadding = "2em";
export const statsPaddingStart = "0 0 1em";
export const statsPaddingMiddle = "1em 0";
export const statsPaddingEnd = "1em 0 0";